import React from 'react';
import PropTypes from 'prop-types';
import Notification from '../Notification/Notification';

const NotificationSomethingWrong = () =>
  <Notification>
    Oops! Sorry, it looks like something went wrong. Please try again.
  </Notification>
;

NotificationSomethingWrong.propTypes = {
  children: PropTypes.node
};

export default NotificationSomethingWrong;



/** WEBPACK FOOTER **
 ** ./src/components/Notification/NotificationSomethingWrong.js
 **/